import 'sbf-design-system-component/broadcast_messages/broadcast_message';

$(function () {
  let refocus = true;

  function escapeHtml (str) {
    const div = document.createElement('div');
    div.appendChild(document.createTextNode(str));
    return div.innerHTML;
  }

  // knockout stuff for search overlay
  // meta-data in cards
  function EntityMetaData (icon, text) {
    const self = this;
    self.icon = icon;
    self.text = escapeHtml(text);
    self.listitemclass = '';

    this.iconclass = ko.computed(function () {
      // here we choose the class for the icon
      switch (self.icon) {
      case 'date':
        return 'icon-calendar';
      case 'event':
        return 'icon-balloons';
      case 'location':
        return 'icon-pushpin';
      case 'venue':
        return 'icon-flag';
      case 'email':
        return 'icon-envelope';
      case 'address':
        return 'icon-home';
      case 'teamname':
        return 'icon-trophy';
      case 'team':
        return 'icon-trophy';
      case 'age':
        return 'icon-gift';
      case 'diagnosis':
        return 'icon-heart';
      case 'treatment-status':
        return 'icon-info-sign';
      case 'money':
        return 'icon-moneybag';
      case 'participant':
        return 'icon-users';
      case 'profile':
        return 'icon-user';
      case 'campaign':
        return 'icon-flowchart';
      default:
        return 'icon-caret-right';
      }
    });
  }

  // just needs the html for the action
  function EntityAction (html) {
    const self = this;
    self.html = html;
  }

  // main view model
  function EntitySearchResults () {
    const self = this;

    self.entitySearchResults = ko.observableArray([]);
    self.totalSearchResults = ko.observable('');
    self.searchMethod = ko.observable('');
    self.entityType = ko.observable('');
    self.searchTerm = ko.observable('');
    self.locationTerm = ko.observable('');
    self.searchGeoLocationFormattedAddress = ko.observable('');
    self.sortBy = ko.observable('');
    self.order = ko.observable('');
    self.sortOptions = ko.observableArray([]);

    self.searchMethodToggleText = ko.computed(function () {
      if (self.searchMethod() == 'location') {
        return 'return to standard search';
      }

      return 'search by location';
    });

    self.resultsTextPrefix = ko.computed(function () {
      if (self.totalSearchResults() > 0) {
        if (self.searchMethod() == 'location') {
          if (self.searchGeoLocationFormattedAddress() != '') {
            return String(self.totalSearchResults()) + ' result' + (self.totalSearchResults() != 1 ? 's' : '') + ' found near<br />';
          }
        } else {
          if (self.searchTerm() != '') {
            return String(self.totalSearchResults()) + ' result' + (self.totalSearchResults() != 1 ? 's' : '') + ' found for<br />';
          }
        }
      }

      return '';
    });

    self.resultsText = ko.computed(function () {
      if (self.totalSearchResults() > 0) {
        if (self.searchMethod() == 'location') {
          if (self.searchGeoLocationFormattedAddress() != '') {
            return '"' + self.searchGeoLocationFormattedAddress() + '"';
          }
        } else {
          if (self.searchTerm() != '') {
            return '"' + self.searchTerm() + '"';
          }
        }
      }

      return '';
    });

    self.resetResults = function () {
      self.entitySearchResults([]);
      self.totalSearchResults(0);
    };

    self.outputResults = function (results) {
      if (results.length == 0) {
        $('#no-results-error').fadeIn();
      } else {
        try {
          $('#search-results-content').fadeIn();
          $('.more-search-results-link').fadeOut();

          $.each(results, function (index, result) {
            if (index < SEARCH_RESULTS_SIZE) {
              const type = result.modelType;

              switch (type) {
              case 'event':
                var card = self.setEventCard(result);
                break;

              case 'fundraiser':
                var card = self.setFundraiserCard(result);
                break;

              case 'participant':
                var card = self.setParticipantCard(result);
                break;

              case 'team':
                var card = self.setTeamCard(result);
                break;

              case 'campaign':
                var card = self.setCampaignCard(result);
                break;

              case 'fund':
                var card = self.setFundCard(result);
                break;

              case 'kid':
                var card = self.setKidCard(result);
                break;

              case 'memorial':
                var card = self.setMemorialCard(result);
                break;

              default:
                var card = {};
                break;
              }

              self.entitySearchResults.push(card);
            } else { // we have an extra, so show more link
              $('.more-search-results-link').fadeIn();
            }
          });
          privateEventHandleIndicators();
          privateEventToolTipButtonsAssignEventHandlers();
        } catch (e) {
          console.log(e.message);
          $('#entity-search-error').fadeIn();
        }
        $('.nolink').on('click', function (click) {
          click.preventDefault();
        });
      }
    };

    self.setEventCard = function (event) {
      const card = {};
      card.type = 'event';
      card.entitycardclass = 'entity-card event';
      card.imagesrc = '/photo/event/' + event.eventID + '/' + event.eventYear;
      card.name = escapeHtml(event.eventTitle);
      card.nameclass = 'name';
      card.namelink = '#';

      if (event.isWebsiteAllowed == true) {
        card.namelink = '/events/mypage/' + event.eventID + '/' + event.eventYear;
      } else {
        card.nameclass += ' nolink';
      }

      card.isPrivate = parseInt(event.eventAccessTypeID) === 2;

      const metas = [];
      if (event.eventDate) {
        metas.push(new EntityMetaData('date', event.eventDate));
      }

      if (event.location) {
        metas.push(new EntityMetaData('location', event.location));
      }

      if (event.venueName) {
        metas.push(new EntityMetaData('venue', event.venueName));
      }

      if (event.totalDonations != undefined && event.totalDonations.toFixed) {
        metas.push(new EntityMetaData('money', '$' + addCommas(event.totalDonations.toFixed(2)) + ' Raised'));
      }

      if (event.totalParticipants && event.totalParticipants.toFixed) {
        metas.push(new EntityMetaData('participant', event.totalParticipants + ' Participants'));
      }

      card.meta = ko.observableArray(metas);

      card.actions = ko.observableArray([
        new EntityAction('<a class="button success" href="/donate/event/' + event.eventID + '/' + event.eventYear + '">Donate</a>')
      ]);

      return card;
    };

    self.setFundraiserCard = function (fundraiser) {
      const card = {};
      card.type = 'fundraiser';
      card.entitycardclass = 'entity-card fundraiser';
      card.imagesrc = '/photo/fundraiser/' + fundraiser.fundraiserID + '/' + fundraiser.eventYear;
      card.name = escapeHtml(fundraiser.title);
      card.nameclass = 'name';
      card.namelink = '#';

      card.namelink = '/fundraisers/mypage/' + fundraiser.fundraiserID + '/' + fundraiser.eventYear;

      card.isPrivate = false;

      const metas = [];
      if (fundraiser.displayName) {
        metas.push(new EntityMetaData('profile', fundraiser.displayName));
      }

      if (fundraiser.eventDate) {
        metas.push(new EntityMetaData('date', fundraiser.eventDate));
      }

      if (fundraiser.location) {
        metas.push(new EntityMetaData('location', fundraiser.location));
      }

      if (fundraiser.totalDonations != undefined && fundraiser.totalDonations.toFixed) {
        metas.push(new EntityMetaData('money', '$' + addCommas(fundraiser.totalDonations.toFixed(2)) + ' Raised'));
      }

      card.meta = ko.observableArray(metas);

      card.actions = ko.observableArray([
        new EntityAction('<a class="button success" href="/donate/fundraiser/' + fundraiser.fundraiserID + '/' + fundraiser.eventYear + '">Donate</a>')
      ]);

      return card;
    };

    self.setParticipantCard = function (participant) {
      const card = {};
      card.type = 'participant';
      card.entitycardclass = 'entity-card participant';
      card.imagesrc = '/photo/participant/' + participant.participantID;
      card.name = escapeHtml(participant.displayName);
      card.nameclass = 'name';
      card.namelink = '#';
      card.isPrivate = false;

      if (participant.isWebsiteAllowed == true) {
        card.namelink = '/participants/mypage/' + participant.participantID + '/' + participant.eventYear;
      } else {
        card.nameclass += ' nolink';
      }

      const metas = [];
      if (participant.eventDate) {
        metas.push(new EntityMetaData('date', participant.eventDate));
      } else if (card.type == 'participant' && participant.eventID == 1 && participant.virtualParticipationDate) {
        metas.push(new EntityMetaData('date', participant.virtualParticipationDate));
      }

      if (participant.location) {
        metas.push(new EntityMetaData('location', participant.location));
      }

      if (participant.eventTitle) {
        metas.push(new EntityMetaData('event', participant.eventTitle));
      }

      if (participant.teamName) {
        metas.push(new EntityMetaData('teamname', participant.teamName));
      }

      if (participant.totalDonations != undefined && participant.totalDonations.toFixed) {
        metas.push(new EntityMetaData('money', '$' + addCommas(participant.totalDonations.toFixed(2)) + ' Raised'));
      }

      card.meta = ko.observableArray(metas);

      card.actions = ko.observableArray([
        new EntityAction('<a class="button success" href="/donate/participant/' + participant.participantID + '/' + participant.eventYear + '">Donate</a>')
      ]);

      return card;
    };

    self.setTeamCard = function (team) {
      const card = {};
      card.type = 'team';
      card.entitycardclass = 'entity-card team';
      card.imagesrc = '/photo/team/' + team.teamID;
      card.name = escapeHtml(team.teamName);
      card.nameclass = 'name';
      card.namelink = '#';
      card.isPrivate = false;

      if (team.isWebsiteAllowed == true) {
        card.namelink = '/teams/mypage/' + team.teamID + '/' + team.eventYear;
      } else {
        card.nameclass += ' nolink';
      }

      const metas = [];
      if (team.eventDate) {
        metas.push(new EntityMetaData('date', team.eventDate));
      }

      if (team.location) {
        metas.push(new EntityMetaData('location', team.location));
      }

      if (team.eventTitle) {
        metas.push(new EntityMetaData('event', team.eventTitle));
      }

      if (team.totalDonations != undefined && team.totalDonations.toFixed) {
        metas.push(new EntityMetaData('money', '$' + addCommas(team.totalDonations.toFixed(2)) + ' Raised'));
      }

      if (team.totalParticipants && team.totalParticipants.toFixed) {
        metas.push(new EntityMetaData('participant', team.totalParticipants + ' Participants'));
      }

      card.meta = ko.observableArray(metas);

      card.actions = ko.observableArray([
        new EntityAction('<a class="button success" href="/donate/team/' + team.teamID + '/' + team.eventYear + '">Donate</a>')
      ]);

      return card;
    };

    self.setCampaignCard = function (campaign) {
      const card = {};
      card.type = 'campaign';
      card.entitycardclass = 'entity-card campaign';
      card.imagesrc = '/photo/campaign/' + campaign.campaignID;
      card.name = escapeHtml(campaign.name);
      card.nameclass = 'name';
      card.namelink = '#';
      card.namelink = '/campaigns/' + campaign.slug;
      card.isPrivate = false;

      const metas = [];

      if (campaign.totalDonations != undefined && campaign.totalDonations.toFixed) {
        metas.push(new EntityMetaData('money', '$' + addCommas(campaign.totalDonations.toFixed(2)) + ' Raised'));
      }

      if (campaign.totalParticipants && campaign.totalParticipants.toFixed) {
        metas.push(new EntityMetaData('participant', campaign.totalParticipants + ' Participants'));
      }

      if (campaign.totalEvents && campaign.totalEvents.toFixed) {
        metas.push(new EntityMetaData('event', campaign.totalEvents + ' Events'));
      }

      card.meta = ko.observableArray(metas);

      card.actions = ko.observableArray([]);

      return card;
    };

    self.setFundCard = function (fund) {
      const card = {};
      card.type = 'fund';
      card.entitycardclass = 'entity-card fund';
      card.imagesrc = '/photo/fund/' + fund.fundID;
      card.name = escapeHtml(fund.name);
      card.nameclass = 'name';
      card.namelink = '#';
      card.namelink = '/hero-funds/' + fund.slug;
      card.isPrivate = false;

      const metas = [];

      if (fund.totalDonations != undefined && fund.totalDonations.toFixed) {
        metas.push(new EntityMetaData('money', '$' + addCommas(fund.totalDonations.toFixed(2)) + ' Raised'));
      }

      if (fund.totalParticipants && fund.totalParticipants.toFixed) {
        metas.push(new EntityMetaData('participant', fund.totalParticipants + ' Participants'));
      }

      if (fund.totalEvents && fund.totalEvents.toFixed) {
        metas.push(new EntityMetaData('event', fund.totalEvents + ' Events'));
      }

      card.meta = ko.observableArray(metas);

      card.actions = ko.observableArray([
        new EntityAction('<a class="button success" href="/donate/fund/' + fund.fundID + '">Donate</a>')
      ]);

      return card;
    };

    self.setKidCard = function (kid) {
      const card = {};
      card.type = 'kid';
      card.entitycardclass = 'entity-card kid';
      card.imagesrc = '/photo/kid/' + kid.kidID;
      card.name = escapeHtml(kid.displayName);
      card.nameclass = 'name';
      card.namelink = '#';
      card.isPrivate = false;

      if (kid.statusID == 2) {
        card.namelink = '/kids/mypage/' + kid.kidID;
      } else {
        card.nameclass += ' nolink';
      }

      const metas = [];

      if (kid.age && kid.treatmentStatusID) {
        metas.push(new EntityMetaData('age', 'Age ' + kid.age));
      }

      if (kid.location) {
        metas.push(new EntityMetaData('location', kid.location));
      }

      if (kid.diagnosis) {
        metas.push(new EntityMetaData('diagnosis', kid.diagnosis));
      }

      if (kid.treatmentStatus) {
        metas.push(new EntityMetaData('treatment-status', kid.treatmentStatus));
      }

      card.meta = ko.observableArray(metas);

      card.actions = ko.observableArray([]);
      card.type = 'Honored Kid';

      return card;
    };

    self.setMemorialCard = function (memorial) {
      const card = {};
      card.type = 'memorial';
      card.entitycardclass = 'entity-card memorial';
      card.imagesrc = '/photo/memorial/' + memorial.memorialID;
      card.name = escapeHtml(memorial.displayName);
      card.nameclass = 'name';
      card.namelink = '/memorial/' + memorial.memorialID;
      card.isPrivate = false;

      const metas = [];

      if (memorial.location) {
        metas.push(new EntityMetaData('location', memorial.location));
      }

      if (memorial.totalDonations != undefined && memorial.totalDonations.toFixed) {
        metas.push(new EntityMetaData('money', '$' + addCommas(memorial.totalDonations.toFixed(2)) + ' Raised'));
      }

      card.meta = ko.observableArray(metas);

      card.actions = ko.observableArray([
        new EntityAction('<a class="button success" href="/donate/memorial/' + memorial.memorialID + '">Donate</a>')
      ]);

      return card;
    };

    self.updateSearchUrl = function (searchText, searchType, sortBy, radius) {
      // Base url
      let url = $('#search-base-url').val();
      let queryParams = [];
      const utmParams = location.search.substring(1).split('&').filter(p => p.indexOf('utm_') != -1);

      // Add what the user entered in the search box
      if (searchText != '') {
        if (self.searchMethod() == 'location') {
          queryParams.push(encodeURIComponent('location') + '=' + encodeURIComponent(searchText));
          queryParams.push(encodeURIComponent('radius') + '=' + encodeURIComponent(radius));
        } else {
          queryParams.push(encodeURIComponent('search-term') + '=' + encodeURIComponent(searchText));
        }
      }

      if (searchType != '') {
        queryParams.push(encodeURIComponent('type') + '=' + encodeURIComponent(searchType));

        if (searchType != 'a') {
          // Build out the query params and append to the url
          if (sortBy == '') {
            sortBy = self.sortBy();
          }
          queryParams.push(encodeURIComponent('sort-by') + '=' + encodeURIComponent(sortBy));
          queryParams.push(encodeURIComponent('order') + '=' + encodeURIComponent(self.order()));
        }
      }

      if (utmParams.length > 0) {
        queryParams = queryParams.concat(utmParams);
      }

      if (queryParams.length > 0) {
        url += '?' + queryParams.join('&');
      }

      const History = window.History;
      if (!History.enabled) {
        // No history available, check to see if the search has been modified.
        // If it has, redirect to that page.
        let rootUrl = document.location.protocol + '//' + (document.location.hostname || document.location.host);
        if (document.location.port || false) {
          rootUrl += ':' + document.location.port;
        }

        // Strip the root url off of the current href and you should have the calculated url
        const currentUrl = document.location.href.replace(rootUrl, '');
        if (currentUrl != url) {
          // redirect by default
          window.location.replace(url);
          return false;
        }
      }

      // Update the browser location bar
      History.replaceState(null, $(document).attr('title'), url);
    };

    self.updateSortOptions = function (e) {
      // reset these since not all entities have the same sort options
      self.entityType($('#search-filter-type').val());

      switch (self.entityType()) {
      case 'e':
        $('.sort-tool').fadeIn();
        self.sortBy('total_donations');
        self.order('desc');
        self.sortOptions([
          { text: 'Donation Amount', value: 'total_donations' },
          { text: 'Participant Count', value: 'total_participants' },
          { text: 'Event Title', value: 'event_title' },
          { text: 'Venue Name', value: 'venue_name' },
          { text: 'City', value: 'city' },
          { text: 'State', value: 'state' },
          { text: 'Event Date', value: 'event_date' }
        ]);
        break;

      case 'p':
        $('.sort-tool').fadeIn();
        self.sortBy('total_donations');
        self.order('desc');
        self.sortOptions([
          { text: 'Donation Amount', value: 'total_donations' },
          { text: 'Name', value: 'display_name' },
          { text: 'Event Title', value: 'event_title' },
          { text: 'Venue Name', value: 'venue_name' },
          { text: 'City', value: 'city' },
          { text: 'State', value: 'state' },
          { text: 'Event Date', value: 'event_date' }
        ]);
        break;

      case 't':
        $('.sort-tool').fadeIn();
        self.sortBy('total_donations');
        self.order('desc');
        self.sortOptions([
          { text: 'Donation Amount', value: 'total_donations' },
          { text: 'Name', value: 'team_name' },
          { text: 'Team Size', value: 'total_participants' },
          { text: 'Event Title', value: 'event_title' },
          { text: 'Venue Name', value: 'venue_name' },
          { text: 'City', value: 'city' },
          { text: 'State', value: 'state' },
          { text: 'Event Date', value: 'event_date' }
        ]);
        break;

      case 'c':
        $('.sort-tool').fadeIn();
        self.sortBy('total_donations');
        self.order('desc');
        self.sortOptions([
          { text: 'Donation Amount', value: 'total_donations' },
          { text: 'Event Count', value: 'total_events' },
          { text: 'Participant Count', value: 'total_participants' },
          { text: 'Campaign Name', value: 'name' }
        ]);
        break;

      case 'f':
        $('.sort-tool').fadeIn();
        self.sortBy('total_donations');
        self.order('desc');
        self.sortOptions([
          { text: 'Donation Amount', value: 'total_donations' },
          { text: 'Event Count', value: 'total_events' },
          { text: 'Participant Count', value: 'total_participants' },
          { text: 'Fund Name', value: 'name' }
        ]);
        break;

      case 'fr':
        $('.sort-tool').fadeIn();
        self.sortBy('total_donations');
        self.order('desc');
        self.sortOptions([
          { text: 'Donation Amount', value: 'total_donations' },
          { text: 'Fundraiser Name', value: 'title' },
          { text: 'Participant Name', value: 'display_name' },
          { text: 'City', value: 'city' },
          { text: 'State', value: 'state' },
          { text: 'Start Date', value: 'start_date' }
        ]);
        break;

      case 'k':
        $('.sort-tool').fadeIn();
        self.sortBy('display_name');
        self.order('asc');
        self.sortOptions([
          { text: 'Name', value: 'display_name' },
          { text: 'City', value: 'city' },
          { text: 'State', value: 'state' },
          { text: 'Diagnosis', value: 'diagnosis_id' },
          { text: 'Treatment Status', value: 'treatment_status_id' }
        ]);
        break;

      case 'me':
        $('.sort-tool').fadeIn();
        self.sortBy('total_donations');
        self.order('desc');
        self.sortOptions([
          { text: 'Donation Amount', value: 'total_donations' },
          { text: 'Memorial Name', value: 'display_name' },
          { text: 'City', value: 'city' },
          { text: 'State', value: 'state' }
        ]);
        break;

      default:
        // everything search without sorting
        $('.sort-tool').fadeOut(0);
        self.entityType('a');
        self.sortBy('');
        self.order('');
        self.sortOptions([]);
        break;
      }
    };

    self.doToggleSearchMethod = function (e) {
      let autoSubmit = false;

      if (self.searchMethod() == 'location') {
        self.searchMethod('standard');
        $('.radius-tool').fadeOut(0);
        $('.keyword-tool').fadeIn(600);

        $("<option value='c'>Campaigns</option>").insertBefore('select#search-filter-type option:nth-child(5)');
        $("<option value='f'>Funds</option>").insertBefore('select#search-filter-type option:nth-child(6)');

        if (self.searchTerm() != '') {
          autoSubmit = true;
        }
      } else {
        self.searchMethod('location');

        $('select#search-filter-type option').filter("[value='c']").remove();
        $('select#search-filter-type option').filter("[value='f']").remove();

        $('.keyword-tool').fadeOut(0);
        $('.radius-tool').fadeIn(600);
        if (self.locationTerm() != '') {
          autoSubmit = true;
        }
      }

      self.resetResults();
      if (autoSubmit) {
        $('#entity-search-form').trigger('submit');
      } else {
        $('#no-results-error, #entity-search-error, #search-results-content').hide();
        $('#entity-search-try-search').show();
      }
    };

    self.doEntityTypeChange = function (e) {
      self.updateSortOptions();
    };

    self.doSortByChange = function (e) {
      // these sort by fields should default to ascending. Otherwise, default to descending since the sort by is changing.
      const defaultAsc = ['title', 'name', 'city', 'state', 'display_name', 'venue_name', 'team_name'];
      const sortBy = self.sortBy();
      if ($.inArray(sortBy, defaultAsc) != -1) {
        // default for display name should be asc
        self.order('asc');
      } else {
        self.order('desc');
      }
    };

    self.doOrder = function (e) {
      const order = self.order() == 'desc' ? 'asc' : 'desc';
      self.order(order);
      $('#entity-search-form').trigger('submit');
    };

    self.entitySearch = function (searchText, searchType, sortBy) {
      searchText = $.trim(searchText);
      if (searchText == '') {
        return false;
      }

      if (window.viewModel.updateSearchUrl(searchText, searchType, sortBy) === false) {
        return false;
      }

      self.searchTerm(searchText);

      // default order if not everything search and order not valid
      const order = self.order();
      if (searchType != 'a' && self.order() != 'asc' && self.order() != 'desc') {
        self.order('asc');
      }

      $('#entity-search-try-search, #entity-search-try-search-mobile, #no-results-error, #entity-search-error').hide();
      $('#search-results-container').addClass('loading');
      $('.orderable').fadeOut();
      $.ajax({
        url: '/frontend/ajax/everything-search',
        type: 'post',
        dataType: 'json',
        data: {
          searchText,
          searchType,
          sortBy,
          orderDirection: self.order(),
          maxResults: SEARCH_RESULTS_SIZE + 1,
          offset: SEARCH_RESULTS_SIZE * searches_run
        },
        success: function (data) {
          if (data.total_count != null && data.results) {
            saved_search_text = searchText;
            saved_search_type = searchType;
            saved_sort_by = sortBy;
            searches_run += 1;
            window.viewModel.totalSearchResults(data.total_count);
            window.viewModel.outputResults(data.results);
            if (searchType != 'a') {
              $('.orderable').fadeIn();
            }
          } else if (data.total_count == 0) {
            window.viewModel.resetResults();
            $('#no-results-error').fadeIn(function () {
              $(this).removeClass('hidden');
            });
          } else {
            window.viewModel.resetResults();
            $('#entity-search-error').fadeIn();
          }
        },
        error: function (jqXHR) {
          window.viewModel.resetResults();
          $('#entity-search-error').fadeIn();
        },
        complete: function () {
          $('#search-results-container').removeClass('loading');
          if (refocus) {
            $('#entity-search-input').focus();
          }
        }
      });
    };

    self.entityGeoLocationSearch = function (locationText, searchType, sortBy, latitude, longitude, radius) {
      locationText = $.trim(locationText);
      if (locationText == '') {
        return false;
      }

      if (window.viewModel.updateSearchUrl(locationText, searchType, sortBy, radius) === false) {
        return false;
      }

      self.locationTerm(locationText);

      // default order if not everything search and order not valid
      const order = self.order();
      if (searchType != 'a' && self.order() != 'asc' && self.order() != 'desc') {
        self.order('asc');
      }

      $('#entity-search-try-search, #no-results-error, #entity-search-error').hide();
      $('#search-results-container').addClass('loading');
      $('.orderable').fadeOut();
      $.ajax({
        url: '/frontend/ajax/everything-search',
        type: 'post',
        dataType: 'json',
        data: {
          searchType,
          sortBy,
          radius,
          latitude,
          longitude,
          orderDirection: self.order(),
          maxResults: SEARCH_RESULTS_SIZE + 1,
          offset: SEARCH_RESULTS_SIZE * searches_run
        },
        success: function (data) {
          if (data.total_count != null && data.results) {
            saved_location_text = locationText;
            saved_latitude = latitude;
            saved_longitude = longitude;
            saved_radius = radius;
            saved_search_type = searchType;
            saved_sort_by = sortBy;
            searches_run += 1;
            window.viewModel.totalSearchResults(data.total_count);
            window.viewModel.outputResults(data.results);
            if (searchType != 'a') {
              $('.orderable').fadeIn();
            }
          } else if (data.total_count == 0) {
            window.viewModel.resetResults();
            $('#no-results-error').fadeIn(function () {
              $(this).removeClass('hidden');
            });
          } else {
            window.viewModel.resetResults();
            $('#entity-search-error').fadeIn();
          }
        },
        error: function (jqXHR) {
          window.viewModel.resetResults();
          $('#entity-search-error').fadeIn();
        },
        complete: function () {
          $('#search-results-container').removeClass('loading');
          if (refocus) {
            $('#entity-search-input').focus();
          }
        }
      });
    };

    self.getTrackingSearchType = function (searchType) {
      // Set tracking event action from searchType
      switch (searchType) {
      case 'e':
        return sbf.google_analytics.event_action_event_search;

      case 'p':
        return sbf.google_analytics.event_action_participant_search;

      case 't':
        return sbf.google_analytics.event_action_team_search;

      case 'c':
        return sbf.google_analytics.event_action_campaign_search;

      case 'f':
        return sbf.google_analytics.event_action_fund_search;

      case 'fr':
        return sbf.google_analytics.event_action_fundraiser_search;

      case 'k':
        return sbf.google_analytics.event_action_kid_search;

      case 'me':
        return sbf.google_analytics.event_action_memorial_search;

      case 'a':
      default:
        return sbf.google_analytics.event_action_everything_search;
      }
    };

    self.searchMethod('standard');
    if ($('#search-method').attr('data-value') == 'location') {
      self.doToggleSearchMethod();
    }

    self.updateSortOptions();
    self.sortBy($('#search-sort').attr('data-value'));
    self.order($('#search-order').attr('data-value'));
    $('.orderable').fadeOut();
  }

  var SEARCH_RESULTS_SIZE = 50;
  var searches_run = 0;
  var saved_location_text = null;
  var saved_search_text = null;
  var saved_search_type = null;
  var saved_sort_by = null;
  var saved_latitude = null;
  var saved_longitude = null;
  var saved_radius = null;

  // bind things here
  window.viewModel = new EntitySearchResults();
  ko.applyBindings(window.viewModel);

  // these are the functions that handle the overlay and starting the search which
  // can be done in a couple different ways
  $('#entity-search-form').bind('submit', function (submit) {
    refocus = true;
    submit.preventDefault();

    let search_input;
    if (window.viewModel.searchMethod() == 'location') {
      search_input = $.trim($('#entity-radius-input').val());
    } else {
      search_input = $.trim($('#entity-search-input').val());
    }

    if (search_input == '') {
      return false;
    }

    if ($.trim($('#search-filter-type').val()) == '') {
      return false;
    }

    if ($.trim($('#search-filter-type').val()) != 'a' && $.trim($('#sort-by').val()) == '') {
      return false;
    }

    // reset variables
    saved_search_text = null;
    saved_search_type = null;
    saved_sort_by = null;
    saved_latitude = null;
    saved_longitude = null;
    saved_radius = null;
    searches_run = 0;

    // this line is so the ipad keyboard hides when you submit it :)
    if (window.viewModel.searchMethod() == 'location') {
      $('#entity-radius-input').blur();
    } else {
      $('#entity-search-input').blur();
    }

    $('#search-results-content').hide();
    $('.more-search-results-link').hide();
    window.viewModel.resetResults();

    if (window.viewModel.searchMethod() == 'location') {
      if (search_input != '') {
        geocoder.geocode({ address: search_input }, function (results, status) {
          if (status == google.maps.GeocoderStatus.OK) {
            window.viewModel.searchGeoLocationFormattedAddress(results[0].formatted_address);
            window.viewModel.entityGeoLocationSearch(search_input, $('#search-filter-type').val(), $('#sort-by').val(), results[0].geometry.location.lat(), results[0].geometry.location.lng(), $('#search-radius').val());
          } else {
            return false;
          }
        });
      } else {
        return false;
      }
    } else {
      window.viewModel.entitySearch(search_input, $('#search-filter-type').val(), $('#sort-by').val());
    }
  });

  // Formats numbers with commas (10432352.00 -> 10,432,352.00)
  var addCommas = function (nStr) {
    nStr += '';
    const x = nStr.split('.');
    let x1 = x[0];
    const x2 = x.length > 1 ? '.' + x[1] : '';
    const rgx = /(\d+)(\d{3})/;
    while (rgx.test(x1)) {
      x1 = x1.replace(rgx, '$1' + ',' + '$2');
    }
    return x1 + x2;
  };

  $('#entity-search-button').bind('click', function (click) {
    click.preventDefault();
    $('#entity-search-form').trigger('submit');
  });

  $('#entity-radius-button').bind('click', function (click) {
    click.preventDefault();
    $('#entity-search-form').trigger('submit');
  });

  // these are the functions that handle the overlay and starting the search which
  // can be done in a couple different ways
  $('#kid-search-form').bind('submit', function (submit) {
    refocus = true;
    submit.preventDefault();

    const searchType = 'k';

    if ($.trim($('#kid-search-input').val()) == '') {
      return false;
    }

    // reset variables
    saved_search_text = null;
    saved_search_type = null;
    saved_sort_by = null;
    searches_run = 0;

    // this line is so the ipad keyboard hides when you submit it :)
    $('#kid-search-input').blur();
    $('#search-results-content').hide();
    window.viewModel.resetResults();

    window.viewModel.entitySearch($('#kid-search-input').val(), searchType);
  });

  $('#kid-search-button').bind('click', function (click) {
    click.preventDefault();
    $('#kid-search-form').trigger('submit');
  });

  $('.more-search-results-link').on('click', function (click) {
    refocus = false;
    click.preventDefault();
    $('.more-search-results-link').hide(); // so button is not present while searching
    if (window.viewModel.searchMethod() == 'location') {
      window.viewModel.entityGeoLocationSearch(saved_location_text, saved_search_type, saved_sort_by, saved_latitude, saved_longitude, saved_radius);
    } else {
      window.viewModel.entitySearch(saved_search_text, saved_search_type, saved_sort_by);
    }
  });

  $('.nolink').on('click', function (click) {
    click.preventDefault();
  });

  // trigger search on page load and focus on input box
  $('#entity-search-form').trigger('submit');
  $('#entity-search-input').focus();

  // trigger search on page load and focus on input box
  $('#kid-search-form').trigger('submit');
  $('#kid-search-input').focus();

  $('#entity-search-form input').keydown(function (e) {
    if (e.keyCode == 13) {
      $('#entity-search-form').submit();
    }
  });
});

/**
 * Workaround for showing the private event label and tooltip.
 *
 * @return    none
 */
const privateEventHandleIndicators = () => {
  $('#search-results-container .private-event-label').each(function () {
    const $this = $(this);
    if ($this.html() === 'true') {
      $this.prev('.type').hide();
      $this.html('PRIVATE EVENT').css('display', 'inline-block').next('span.private-event-tooltip-button').css('display', 'inline-block');

      $('<br/>').insertAfter(
        $this.next('span.private-event-tooltip-button')
      );
    }
  });
};

/**
 * Assign event handlers for private event tooltip buttons.
 *
 * @return    none
 */
const privateEventToolTipButtonsAssignEventHandlers = () => {
  $('#search-results-container .private-event-tooltip-button').each(function () {
    privateEventTooltipButtonAssignEventHandlers($(this));
  });
};

/**
 * Assign event handlers for private event tooltip button.
 *
 * @param     object    $button    A jquery wrapped HTML element.
 * @return    none
 */
const privateEventTooltipButtonAssignEventHandlers = ($button) => {
  // Button - mouse enter event.
  $button.unbind('mouseenter').bind('mouseenter', function () {
    const $this  = $(this);
    const $popup = $('.private-event-tooltip-popoup');
    if ($popup.length) {
      const buttonOffset = $this.offset();
      const buttonHeight = $this.height();
      const popupWidth   = $popup.width();
      const popupHeight  = $popup.height();
      const popupPadding = parseInt($popup.css('padding'));
      $popup.css({
        'display': 'block',
        'top': buttonOffset.top - popupHeight - (popupPadding * 2) - buttonHeight,
        'left': buttonOffset.left - parseInt(popupWidth / 2)
      });
    }
  });
  // Button - mouse leave event.
  $button.unbind('mouseleave').bind('mouseleave', function () {
    $('.private-event-tooltip-popoup').css('display', 'none');
  });
};
